import { TextMap } from "../../types";

const de: TextMap = {
  choose_preferred_wallet: "Wähle bevorzugte Wallet",
  connect_mobile_wallet: "Verbinde mit Mobile Wallet",
  scan_qrcode_with_wallet: "Scanne den QR-code mit einer WalletConnect kompatiblen Wallet",
  connect: "Verbinden",
  // TODO: review following translations
  qrcode: "QR-Code",
  mobile: "Mobile",
  copy_to_clipboard: "In die Zwischenablage kopieren",
  copied_to_clipboard: "In die Zwischenablage kopiert!",
  show_more: "Zeig mehr",
  show_less: "Zeige weniger",
};

export default de;
